import { IPROP_MAP } from '../../generators/modifyProps';
import { JDSTooltipProps } from './generated';

const legacyTooltipPositions = [
  'right-start',
  'right-end',
  'bottom-start',
  'bottom-end',
  'left-start',
  'left-end',
  'top-start',
  'top-end'
] as const;

type legacyTooltipPositionsType = (typeof legacyTooltipPositions)[number];

export type TooltipPosition =
  | legacyTooltipPositionsType
  | JDSTooltipProps['position'];

export interface TooltipProps
  extends Omit<
    JDSTooltipProps,
    'position' | 'onAppear' | 'offsetX' | 'offsetY' | 'triggerRef' | 'onHover'
  > {
  position?: TooltipPosition;
  label?: string;
  children?: React.ReactNode;
}

export const PROP_MAP: IPROP_MAP<TooltipProps> = (props) => {
  if (
    legacyTooltipPositions.includes(
      props.position as legacyTooltipPositionsType
    )
  ) {
    console.warn(
      'these values for the position prop are deprecated',
      legacyTooltipPositions
    );
  }
  return {
    position: {
      variations: {
        'right-start': {
          position: 'right_start'
        },
        'left-start': {
          position: 'left_start'
        },
        'bottom-start': {
          position: 'bottom_start'
        },
        'top-start': {
          position: 'top_start'
        },
        'left-end': {
          position: 'left_end'
        },
        'right-end': {
          position: 'right_end'
        },
        'top-end': {
          position: 'top_end'
        },
        'bottom-end': {
          position: 'bottom_end'
        },
        left: {
          position: 'left'
        },
        right: {
          position: 'right'
        },
        top: {
          position: 'top'
        },
        bottom: {
          position: 'bottom'
        }
      }
    }
  };
};
